import { track } from '@/features/shared/analytics/trackingQueue'
import { urlPathnameToLocationName } from '@/features/shared/analytics/utils'
import { AnalyticsEvent } from '@shipt/analytics-member-web'

export const trackSegmentConsentPreferenceUpdated = () => {
  track({
    eventName: AnalyticsEvent.SegmentConsentPreferenceUpdated,
    properties: { location: urlPathnameToLocationName() },
  })
}
